
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_7nfqu_1x45y_13",
  "has-adaptive-widths-default": "awsui_has-adaptive-widths-default_7nfqu_1x45y_57",
  "has-adaptive-widths-dashboard": "awsui_has-adaptive-widths-dashboard_7nfqu_1x45y_62",
  "drawer-expanded-mode": "awsui_drawer-expanded-mode_7nfqu_1x45y_77",
  "ai-drawer-expanded-mode": "awsui_ai-drawer-expanded-mode_7nfqu_1x45y_80",
  "bottom-drawer-expanded-mode": "awsui_bottom-drawer-expanded-mode_7nfqu_1x45y_83",
  "ai-drawer": "awsui_ai-drawer_7nfqu_1x45y_80",
  "navigation": "awsui_navigation_7nfqu_1x45y_90",
  "tools": "awsui_tools_7nfqu_1x45y_91",
  "global-tools": "awsui_global-tools_7nfqu_1x45y_92",
  "bottom-tool": "awsui_bottom-tool_7nfqu_1x45y_93",
  "navigation-collapsed": "awsui_navigation-collapsed_7nfqu_1x45y_142",
  "tools-open": "awsui_tools-open_7nfqu_1x45y_155",
  "split-panel-side": "awsui_split-panel-side_7nfqu_1x45y_169",
  "split-panel-bottom": "awsui_split-panel-bottom_7nfqu_1x45y_176",
  "panel-hidden": "awsui_panel-hidden_7nfqu_1x45y_189",
  "toolbar-container": "awsui_toolbar-container_7nfqu_1x45y_199",
  "pseudo-toolbar": "awsui_pseudo-toolbar_7nfqu_1x45y_213",
  "pseudo-toolbar-content": "awsui_pseudo-toolbar-content_7nfqu_1x45y_231",
  "notifications-container": "awsui_notifications-container_7nfqu_1x45y_275",
  "notifications-background": "awsui_notifications-background_7nfqu_1x45y_279",
  "main-landmark": "awsui_main-landmark_7nfqu_1x45y_290",
  "main": "awsui_main_7nfqu_1x45y_290",
  "main-disable-paddings": "awsui_main-disable-paddings_7nfqu_1x45y_299",
  "content-header": "awsui_content-header_7nfqu_1x45y_309",
  "content": "awsui_content_7nfqu_1x45y_309",
  "unfocusable-mobile": "awsui_unfocusable-mobile_7nfqu_1x45y_319",
  "hidden": "awsui_hidden_7nfqu_1x45y_324",
  "breadcrumbs-own": "awsui_breadcrumbs-own_7nfqu_1x45y_328",
  "breadcrumbs-discovered": "awsui_breadcrumbs-discovered_7nfqu_1x45y_328"
};
  